exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"style.scss?vue&type=style&index=0&id=f0dcf6d2&prod&lang=scss&scoped=true&","sourceRoot":""}]);

// exports
